import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/** Collapsed "why / troubleshooting" notes under a setting. */
export default function Why({ title = 'Why / troubleshooting', children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-4 rounded-lg bg-neutral-50 dark:bg-neutral-900/40">
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium text-neutral-700 dark:text-neutral-300">
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        {title}
      </button>
      {open && <div className="space-y-2 px-4 pb-4 text-sm text-neutral-600 dark:text-neutral-300">{children}</div>}
    </div>
  );
}
